import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const DEFAULT_COLOR = '#6b7280';
const isHexColor = (color) => /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(color.trim());
const hexToRgba = (color, alpha) => {
    let hex = color.replace('#', '');
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map(char => char + char)
            .join('');
    }
    const num = parseInt(hex, 16);
    const r = (num >> 16) & 255;
    const g = (num >> 8) & 255;
    const b = num & 255;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
const applyAlpha = (color, alpha) => {
    if (isHexColor(color)) {
        return hexToRgba(color, alpha);
    }
    if (color.startsWith('rgb(')) {
        const values = color
            .replace(/rgb\(|\)|\s/g, '')
            .split(',')
            .map(Number)
            .slice(0, 3);
        if (values.length === 3 && values.every(value => Number.isFinite(value))) {
            return `rgba(${values[0]}, ${values[1]}, ${values[2]}, ${alpha})`;
        }
    }
    return color;
};
const StatCard = ({ icon, label, value, color, onClick, isActive }) => {
    const baseColor = color && color.trim() ? color : DEFAULT_COLOR;
    const buttonStyle = {
        borderLeftColor: baseColor,
    };
    const iconWrapperStyle = {
        color: baseColor,
        backgroundColor: applyAlpha(baseColor, 0.15),
    };
    return (_jsxs("button", { type: "button", onClick: onClick, style: buttonStyle, className: `flex items-center p-4 rounded-lg shadow-md border-l-4 bg-white text-left transition-transform duration-150 focus:outline-none ${onClick ? 'cursor-pointer hover:-translate-y-1' : ''} ${isActive ? 'ring-2 ring-offset-2' : ''}`, children: [_jsx("div", { className: "mr-4 p-4 rounded-lg flex items-center justify-center", style: iconWrapperStyle, children: icon }), _jsxs("div", { children: [_jsx("p", { className: "text-sm text-gray-600", children: label }), _jsx("p", { className: "text-xl font-semibold text-gray-800", children: value })] })] }));
};
export default StatCard;
